import React , {useState,useEffect }from "react";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Tooltip } from "@vds/tooltips";
import { updateSCTags ,tempSCData} from './../../../../Source/src/service/dtmTag';
import { tempVzdlSCData, updateVzdlSCCustomEvent } from "../../service/vzdl";
import CloseIcon from '@vds/icons/close';
import { connect } from 'react-redux';
import { openModalWindow, closeModalWindow } from '../../action/modalWindow';


function MnhModal({
  product = null,
  buildProduct = null,
  mnhTooltip = "",
  mnhTooltipdesc="",
  formattedWasPriceWithAP="",
  flowType = '',
  signInClick = () => { },
  dispatch = () => {},
  modalWindowState

})  {
  const is2GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3582" || item?.name?.toUpperCase?.()?.includes?.("2 GIG")) > -1;
  const isGigabitPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => !is2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIGABIT CONNECTION")) > -1;
  const is1GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3583" || (!is2GigPlan && !isGigabitPlan && item?.name?.toUpperCase?.()?.includes?.("GIG"))) > -1;
  const isMax500Plan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => (!is2GigPlan && !isGigabitPlan && !is1GigPlan && item?.name?.toUpperCase?.()?.includes?.("500 MBPS"))) > -1;
  const productName = product?.productName || product?.name || product?.prodName;
  function handlePrimaryClick(e) {
    try {
      //closeModalWindow("MNHMODELOVERLAY", dispatch); 
      signInClick(e);
      //setCloseModal(false);
      
      updateSCTags("sign in","","Mobile + Home overlay");
    } catch (e) {
      console.error(e);
    }
  }
  const [closeModal,setCloseModal]=useState((modalWindowState?.modalId === `${'MNHMODELOVERLAY_'}${product?.id}`))
  const handleClose= () => {
    //setCloseModal(false); 
    closeModalWindow(`${'MNHMODELOVERLAY_'}${product?.id}`, dispatch, 'MNHMODEL');
    updateSCTags("close","","Mobile + Home overlay");
  }
  const crossSign = () =>{
    closeModalWindow(`${'MNHMODELOVERLAY_'}${product?.id}`, dispatch, 'MNHMODEL');
    //setCloseModal(false); 
    updateSCTags("Close sign","","Mobile + Home overlay");
  }
  const tooltipOpen = () =>{
    //setCloseModal(true)
    
    openModalWindow(`${'MNHMODELOVERLAY_'}${product?.id}`, dispatch, 'MNHMODEL','','','',product?.id);
    updateSCTags("Mobile + Home tooltip")
    tempVzdlSCData.detail = "Mobile + Home overlay";
    if (flowType === true){
      tempVzdlSCData.name = "Streamline Buildproducts - Internet & Perks"
      setTimeout(()=>{
        updateVzdlSCCustomEvent("mnhModalOverlay","pageViewOmni","details,name")},1000)
    }else{
      setTimeout(()=>{
        updateVzdlSCCustomEvent("mnhModalOverlay","pageViewOmni","details")},1000)
    }
  }

  useEffect(() => {
    if(modalWindowState.modalId===`${'MNHMODELOVERLAY_'}${product?.id}`){
      setCloseModal(true)
      const focusSignCTA = document?.body?.getAttribute("focusMnhSignInCTA");
      if(focusSignCTA === "true"){
        setTimeout(() => {
          const el = document?.getElementById("mnhSignInCTA");
          if(el){
            el?.focus();
            document?.body?.removeAttribute("focusMnhSignInCTA");
          }
        }, 100);
      }
    }
    else{
      setCloseModal(false)
    }

  },[modalWindowState])
 //console.log(modalWindowState, product, 'modalWindowState')
  return (
    <span className="MnhModalContainer">
      <button id="MnhModalBtn" aria-label={"more information as low as $" + formattedWasPriceWithAP}
        type="button" style={{ cursor: "pointer", padding: "0", verticalAlign: "middle" }} onClick={() => tooltipOpen()}>
        <Tooltip disabled={true} size="small" surface="dark" />
      </button>
      {!!closeModal && (
        <Modal
          disableOutsideClick={true}
          opened={closeModal}
          onOpenedChange={(modalOpened) => setCloseModal(modalOpened)}
          closeButton={(<button aria-label="Close" className="mnTooltipModal" onClick={()=>crossSign()} ><CloseIcon size="23"  tabIndex="0"/></button>)}
          closeButtonId='mnTooltip-Modal-new'
          id='mnTooltip-Modal'
        >
          <ModalTitle>
            Mobile + Home Discount
          </ModalTitle>
          <ModalBody>
            <div style={{paddingTop:"32px", paddingBottom:"32px"}}>
              {(buildProduct?.emberInfo?.isEmberFlow && (productName?.toUpperCase?.()?.includes?.("GIG") || (isMax500Plan && productName?.toUpperCase?.()?.includes?.("500 MBPS")))) ? (
                <>
                  <p style={{ marginBottom: 20, marginTop: 20, fontSize: "1rem" }}>
                    Save $15/mo when on any postpaid mobile plan. {(is2GigPlan ? "1 Gig or 2 Gig" : isGigabitPlan ? "Gigabit Connection" : is1GigPlan ? "1 Gig" : "500 Mbps")} customers also get a $10/mo credit on any eligible perk. Mobile + Home discount enrollment req'd.
                  </p>
                  <p style={{ marginBottom: 20, marginTop: 20, fontSize: "0.75rem", color: "#6F7171" }}>
                    Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.
                  </p>
                </>
              ) : (
                <>
                  { mnhTooltip }
                  <p className="mnhTooltipdesc">{mnhTooltipdesc}</p>
                </>
              )}
            </div>
          </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                id: "mnhSignInCTA",
                children: "Sign In",
                onClick: e => handlePrimaryClick(e)
              },
              close: {
                children: "Close",
                onClick: () => handleClose()
              }
            }}
          />
        </Modal>
      )}
    </span>
  )
}

const mapStateToProps = state => {
  return {
    modalWindowState: state.modalWindow,
  }
}


export default React.memo(connect(mapStateToProps)(MnhModal));
